import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { List, WingBlank } from 'antd-mobile'
import CardLayout from '../../components/common/CardLayout'
import { FormattedMessage, useIntl } from 'react-intl'
import UploadOssFile from '../../components/common/UploadOssFile'
import UploadFileWrapper from '../../components/common/UploadFileWrapper'
import { findAFDI, findEfriCert, findMasterFD, findOwsi } from '../../components/common/findCerts'
import { removeMFDIFile, uploadMFDIOssFile } from '../../reducers/mfdi'
import OwsiAndPrepare from './OwsiAndPrepare'
import AfdiAndPrepare from './AfdiAndPrepare'

const Item = List.Item

const CheckCerts = ({ efrifiles, mfdfiles, editable, afdifiles, fdipreFiles, complete }) => {
  const { certifications, ossSignature, credentials } = useSelector((state) => ({
    certifications: state.data.certifications,
    credentials: state.data.credentials,
    ossSignature: state.oss.ossSignature,
  }))
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const filename = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`

  return (
    <CardLayout title={<FormattedMessage id="dm-form-required-certs" />} status={complete}>
      {/*
      证书要求：三选一 + EFRI + PADI MFD 或 持有其他组织的MFD
      PADI AFD
      PADI OWSI + 完成 PADI 自由潜水员教练预备课程
      其他组织进阶自由潜水员教练证书 + 完成 PADI 自由潜水员教练预备课程
    */}

      {findAFDI(credentials) ? (
        <Item>
          <FormattedMessage id="mfd-padi-afd" /> <FormattedMessage id="afdi-satisfy" />
        </Item>
      ) : findOwsi(credentials) ? (
        <OwsiAndPrepare afdifiles={afdifiles} editable={editable} />
      ) : (
        <AfdiAndPrepare afdifiles={afdifiles} fdipreFiles={fdipreFiles} editable={editable} />
      )}
      {/* mfd */}
      {findMasterFD(certifications) ? (
        <Item>
          <FormattedMessage id="fdi-master-cert" /> {`（${findMasterFD(certifications).studentNumber}）`}
        </Item>
      ) : (
        <UploadFileWrapper labelName={formatMessage({ id: 'afdi-master-fd' })} editable={editable}>
          <UploadOssFile
            fileList={mfdfiles || []}
            fileName={filename('mfd')}
            onChange={(formData) => {
              dispatch(uploadMFDIOssFile({ formData }))
            }}
            onDelete={(index) => dispatch(removeMFDIFile(mfdfiles[index]))}
            editable={editable}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
      {/* efri */}
      {findEfriCert(credentials) ? (
        <Item>EFRI</Item>
      ) : (
        <UploadFileWrapper labelName={'EFRI'} editable={editable}>
          <UploadOssFile
            fileList={efrifiles || []}
            fileName={filename('efri')}
            onChange={(formData) => {
              dispatch(uploadMFDIOssFile({ formData }))
            }}
            onDelete={(index) => dispatch(removeMFDIFile(efrifiles[index]))}
            editable={editable}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
    </CardLayout>
  )
}

export default CheckCerts
